import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import { Icon } from "semantic-ui-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import LoaderComponent from "../../../libraries/loader/loader";
import {
  Fetchexecutequery,
  Fetchfileupload_1,
  TriggerMail,
} from "../../../services/process/BRS1/brsService7";
import { CreateData} from '../../../services/process/process_data/process_data';

const FILE_SERVICE_BASE = "http://154.61.75.209:1200/api/v2/user_modules";

function ExcelDownloadCell(props) {
  const handleDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const attachmentName = props.data?.attachment_name;
    if (!attachmentName) return;

    const url = `${FILE_SERVICE_BASE}/download-brs-report/${encodeURIComponent(attachmentName)}/`;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_self";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      type="button"
      title={props.data?.attachment_name || "Download report"}
      onClick={handleDownload}
      style={{
        border: "none",
        background: "transparent",
        cursor: "pointer",
        padding: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon name="file excel" color="green" size="large" />
    </button>
  );
}

function FileUploadScreen() {

  // ---------------- STATE ----------------
  const [activeTab, setActiveTab] = useState("upload");
  const tabs = [
    { key: "upload", label: "Upload" },
    { key: "balance", label: "Balance Updation" },
    { key: "mail", label: "Mail Trigger" },
  ];

  const [source, setSource] = useState("txn_dump");
  const [month, setMonth] = useState("");
  const [file, setFile] = useState(null);
  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [logRowData, setLogRowData] = useState([]);
  const [logColumnDefs, setLogColumnDefs] = useState([]);
  const [logLoading, setLogLoading] = useState(false);
  const [triggerLoading, setTriggerLoading] = useState(false);
  const [error, setError] = useState(null);
  const [balanceForm, setBalanceForm] = useState({
    account_no: "",
    balance_date: "",
    bank_balance: "",
    book_balance: "",
  });
  const [balanceAccountOptions, setBalanceAccountOptions] = useState([]);
  const [mailDate, setMailDate] = useState("");

  const gridRef = useRef();
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

  // ---------------- STYLES ----------------
  const fieldBox = {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    padding: "8px",
    background: "white",
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
    minWidth: "180px",
  };

  const labelStyle = {
    fontSize: "15px",
    fontWeight: "600",
    color: "#333",
  };

  const containerStyle = {
    display: "flex",
    gap: "15px",
    alignItems: "flex-end",
    background: "#f5f6fa",
    padding: "20px",
    borderRadius: "10px",
  };

  const customSelectStyles = {
    container: (base) => ({ ...base, width: "220px" }),
  };

  // ---------------- HELPERS ----------------
  async function runQuery(query) {
    const payload = { query };
    const [creds, url] = Fetchexecutequery();
    const res = await axios.post(url, payload, creds);
    return res.data;
  }

  const handleNumericChange = (field, value) => {
    // allow only integers and decimal
    if (/^\d*\.?\d*$/.test(value)) {
      setBalanceForm((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const getFormattedDate = () => {
  const now = new Date();

  const pad = (n) => String(n).padStart(2, "0");

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

const handleBalanceCreate = async () => {

  if (
    !balanceForm.account_no ||
    !balanceForm.bank_balance ||
    !balanceForm.book_balance
  ) {
    alert("Fill all fields");
    return;
  }

  const formattedDate = getFormattedDate();

  const listValue = [
    balanceForm.account_no,
    balanceForm.bank_balance,
    balanceForm.book_balance,
    userCredentials.selectedentity,
  ].join("|");

  try {

    const checkCredentials = Fetchexecutequery();
      const updatedFormData = {
        ...balanceForm,
        created_on: formattedDate,
        last_updated_on: formattedDate,
        entity_id: userCredentials.selectedentity,
        created_by: userCredentials.user_id,
      };

      const createPayloadData = createPayload(
        "sg_brs",
        "daily_balance",
        updatedFormData
      );

      const createCredentials = CreateData();

      const createResponse = await axios.post(
        createCredentials[1],
        createPayloadData,
        createCredentials[0]
      );

      console.log("Create response:", createResponse);

      alert("Balance updated successfully");

      setBalanceForm({
        account_no: "",
        bank_balance: "",
        book_balance: "",
        balance_date: "",
      });

    

  } catch (error) {
    console.error("Error in handleBalanceCreate:", error);
    setError("Error creating balance data");
  }
};

  // ---------------- FETCH DROPDOWNS ----------------
  useEffect(() => {
    const fetchAccounts = async () => {
      const data = await runQuery(`
        SELECT DISTINCT \`Entity Name\` as entity FROM sg_brs.gl_master;
      `);

      setAccountOptions(data.map(r => ({
        value: r.entity,
        label: r.entity
      })));
    };

    fetchAccounts();
  }, []);

  useEffect(() => {
    const fetchAccounts1 = async () => {
      const data = await runQuery(`
        SELECT DISTINCT account_no
        FROM sg_brs.gl_master
        WHERE account_no IS NOT NULL
        ORDER BY account_no;
      `);

      const options = data.map((r) => ({
        value: r.account_no,
        label: r.account_no,
      }));

      setBalanceAccountOptions(options);
    };

    fetchAccounts1();
  }, []);

  // ---------------- FILE UPLOAD ----------------
  const uploadFileToServer = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("filePath", `/home/demo/txn_dump/`);

    const res = await axios.post(
      "http://154.61.75.209:1200/api/v2/user_modules/upload/",
      formData
    );

    return {
      fileName: res.data.Filename,
      filePath: res.data.Filepath,
    };
  };

  const handleUpload = async () => {
    if (!month || !file) {
      alert("Fill all fields");
      return;
    }

    setUploadLoading(true);
    try {
      const uploaded = await uploadFileToServer(file);

      const payload = {
        file_name: uploaded.fileName,
        file_path: uploaded.filePath,
        source_name: "txn_dump",
        table: "txn_dump",
        skiprows: 0,
        config_id: 20,
        month,
        tenants_id: userCredentials.tenants_id,
        groups_id: userCredentials.groups_id,
        entities_id: userCredentials.selectedentity,
        division_id: userCredentials.division,
        department_id: userCredentials.department,
        user_id: userCredentials.user_id,
        process_id: 51,
      };

      

      const creds = Fetchfileupload_1();
      await axios.post(creds[1], payload, creds[0]);

      alert("Upload successful");
      setMonth("");
      setFile(null);

      await fetchUploadHistory();

    } catch (err) {
      alert("Upload failed");
    } finally {
      setUploadLoading(false);
    }
  };

// ---------------- MAIL TRIGGER ----------------
const handleMailTrigger = async () => {

  if (!selectedAccount || !mailDate) {
    alert("Select account and date");
    return;
  }
  const payload = {
    account_no: selectedAccount.value,
    balance_date: mailDate,
  };
  setTriggerLoading(true);
  try {
    const creds = TriggerMail();
    const response = await axios.post(
      creds[1],
      payload,
      creds[0]
    );
    alert(
      response?.data?.message || "Mail triggered"
    );
    try {
      await fetchMailLog(false);
    } catch (refreshErr) {
      console.error("Mail log refresh failed:", refreshErr);
      setError(
        "Mail triggered, but log refresh failed."
      );
    }
  } catch (err) {
    console.error("Mail trigger error:", err);
    // =====================================================
    // BACKEND VALIDATION ERROR
    // =====================================================
    if (
      err.response &&
      err.response.data &&
      err.response.data.missing_account_numbers
    ) {
      const missingAccounts =
        err.response.data.missing_account_numbers;
      alert(
        `Balance missing for below account numbers:\n\n${missingAccounts.join("\n")}`
      );
    }
    // =====================================================
    // NORMAL BACKEND ERROR
    // =====================================================
    else if (
      err.response &&
      err.response.data &&
      err.response.data.message
    ) {
      alert(err.response.data.message);
    }
    // =====================================================
    // UNKNOWN ERROR
    // =====================================================
    else {
      alert("Failed to trigger mail");
    }
  } finally {
    setTriggerLoading(false);
  }
};

// ---------------- HISTORY ----------------
const fetchUploadHistory = async () => {
  const data = await runQuery(`
    SELECT file_name as \`file name\`, status, comments,file_row_count as \`row count\`,
    DATE_FORMAT(uploaded_time, '%d-%m-%Y %H:%i:%s') created_on
    FROM process_data.file_uploads where process_id = 51
    ORDER BY file_uploads_id DESC LIMIT 50;
  `);

  setRowData(data);

  if (data.length) {
    setColumnDefs(Object.keys(data[0]).map(k => ({
      headerName: k,
      field: k
    })));
  }
};

  useEffect(() => {
    fetchUploadHistory();
    fetchMailLog();
  }, []);

  // ---------------- MAIL LOG ----------------
  const fetchMailLog = async (showLoading = true) => {
    if (showLoading) setLogLoading(true);
    try {
      const data = await runQuery(`
        SELECT
          primary_id,
          IFNULL(TRIM(from_email), '') AS from_email,
          IFNULL(TRIM(to_email), '') AS to_email,
          DATE_FORMAT(sent_time, '%d-%m-%Y %H:%i:%s') AS sent_time,
          DATE_FORMAT(created_time, '%d-%m-%Y %H:%i:%s') AS created_time,
          IFNULL(TRIM(attachment_name), '') AS attachment_name,
          IFNULL(TRIM(status), '') AS status
        FROM process_data.email_log
        ORDER BY primary_id DESC
        LIMIT 50;
      `);

      setLogRowData(data);
      if (data.length) {
        setLogColumnDefs([
          { headerName: "Sent Time", field: "sent_time", sortable: true, filter: true },
          { headerName: "Created Time", field: "created_time", sortable: true, filter: true },
          { headerName: "From Email", field: "from_email", sortable: true, filter: true },
          { headerName: "To Email", field: "to_email", sortable: true, filter: true },
          { headerName: "Status", field: "status", sortable: true, filter: true },
          {
            headerName: "Report",
            field: "attachment_name",
            sortable: false,
            filter: false,
            width: 110,
            cellRenderer: ExcelDownloadCell,
          },
        ]);
      } else {
        setLogColumnDefs([]);
      }
    } catch (err) {
      console.error("Mail log fetch failed:", err);
      setError("Error fetching mail log");
    } finally {
      if (showLoading) setLogLoading(false);
    }
  };

  // ---------------- UI ----------------
  return (
    <div style={{ padding: 20 }}>
      <div style={{
  display: "flex",
  borderBottom: "1px solid #E2E5EA",
  marginBottom: 20
}}>
  {tabs.map(t => (
    <div
      key={t.key}
      onClick={() => setActiveTab(t.key)}
      style={{
        padding: "10px 16px",
        cursor: "pointer",
        borderBottom: activeTab === t.key ? "2px solid #2563EB" : "2px solid transparent",
        color: activeTab === t.key ? "#2563EB" : "#6B7280",
        fontWeight: activeTab === t.key ? 600 : 500
      }}
    >
      {t.label}
    </div>
  ))}
</div>
      {/* UPLOAD TAB */}
      {activeTab === "upload" && (
        <>
          <div style={containerStyle}>
            <div style={fieldBox}>
              <label style={labelStyle}>Month</label>
              <input type="date" value={month} onChange={(e) => setMonth(e.target.value)} />
            </div>

            <div style={fieldBox}>
              <label style={labelStyle}>File</label>
              <input type="file" onChange={(e) => setFile(e.target.files[0])} />
            </div>

            <button onClick={handleUpload}>Upload</button>
          </div>

          <div className="ag-theme-alpine" style={{ height: 400, marginTop: 20 }}>
            <AgGridReact rowData={rowData} columnDefs={columnDefs} />
          </div>
        </>
      )}

      {/* BALANCE TAB */}
{activeTab === "balance" && (
  <>
    <div style={containerStyle}>

      <div style={fieldBox}>
        <label style={labelStyle}>Balance Date</label>

        <input
          type="date"
          value={balanceForm.balance_date}
          onChange={(e) =>
            setBalanceForm((prev) => ({
              ...prev,
              balance_date: e.target.value,
            }))
          }
        />
      </div>

      <div style={fieldBox}>
        <label style={labelStyle}>Account No</label>

        <Select
          options={balanceAccountOptions}
          value={
            balanceAccountOptions.find(
              (x) => x.value === balanceForm.account_no
            ) || null
          }
          onChange={(selected) =>
            setBalanceForm((prev) => ({
              ...prev,
              account_no: selected?.value || "",
            }))
          }
        />
      </div>

      <div style={fieldBox}>
        <label style={labelStyle}>Bank Closing Balance</label>

        <input
          type="text"
          value={balanceForm.bank_balance}
          onChange={(e) =>
            handleNumericChange(
              "bank_balance",
              e.target.value
            )
          }
          placeholder="Enter bank balance"
        />
      </div>

      <div style={fieldBox}>
        <label style={labelStyle}>Book Closing Balance</label>

        <input
          type="text"
          value={balanceForm.book_balance}
          onChange={(e) =>
            handleNumericChange(
              "book_balance",
              e.target.value
            )
          }
          placeholder="Enter book balance"
        />
      </div>

      <button onClick={handleBalanceCreate}>
        Save Balance
      </button>

    </div>
  </>
)}

      {/* MAIL TAB */}
      {activeTab === "mail" && (
        <>
          <div style={containerStyle}>
            <div style={fieldBox}>
              <label style={labelStyle}>Entity</label>

              <Select
                options={accountOptions}
                value={selectedAccount}
                onChange={setSelectedAccount}
              />
            </div>

            <div style={fieldBox}>
              <label style={labelStyle}>Date</label>

              <input
                type="date"
                value={mailDate}
                onChange={(e) => setMailDate(e.target.value)}
              />
            </div>

            <button onClick={handleMailTrigger}>Trigger Mail</button>
          </div>

          <div style={{ marginTop: 20 }}>
            <div className="ag-theme-alpine" style={{ height: 400, marginTop: 20 }}>
              <AgGridReact
                rowData={logRowData}
                columnDefs={logColumnDefs}
                pagination={true}
                paginationPageSize={10}
              />
            </div>
          </div>
        </>
      )}

      {(loading || uploadLoading || triggerLoading || logLoading) && (
        <LoaderComponent loaderOpen={true} />
      )}
    </div>
  );
}

export default FileUploadScreen;
